const Input = ({ 
  label, 
  type = "text", 
  placeholder, 
  value, 
  onChange, 
  error, 
  required = false,
  className = "",
  name,
  ...props 
}) => {
  const handleChange = (e) => {
    // For M-Pesa number fields, apply formatting
    if (name === 'mpesaNumber') {
      let newValue = e.target.value;
      
      // Remove non-digits
      newValue = newValue.replace(/\D/g, '');
      
      // Limit to 10 digits
      if (newValue.length > 10) {
        newValue = newValue.slice(0, 10);
      }
      
      // Add spacing for readability
      if (newValue.length > 3) {
        newValue = newValue.slice(0, 3) + ' ' + newValue.slice(3);
      }
      if (newValue.length > 7) {
        newValue = newValue.slice(0, 7) + ' ' + newValue.slice(7);
      }
      
      // Create modified event
      const modifiedEvent = {
        target: {
          name: name,
          value: newValue
        }
      };
      
      onChange(modifiedEvent);
    } else {
      // For all other fields, pass the original event
      onChange(e);
    }
  };

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <input
        type={type}
        name={name}
        placeholder={placeholder}
        value={value || ''}
        onChange={handleChange}
        className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent ${
          error ? 'border-red-500' : 'border-gray-300'
        }`}
        {...props}
      />
      {name === 'mpesaNumber' && (
        <p className="mt-1 text-xs text-gray-500">Format: 07X XXX XXXX or 01X XXX XXXX</p>
      )}
      {error && (
        <p className="mt-1 text-sm text-red-500">{error}</p>
      )}
    </div>
  );
};

export default Input;